var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-btn',{attrs:{"icon":""},on:{"click":_vm.onClick}},[_c('v-icon',{attrs:{"color":_vm.loading
        ? 'grey lighten-3'
        : _vm.localActive
        ? 'yellow darken-2'
        : 'grey lighten-1'}},[_vm._v(" fa-star ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }